<template>
  <v-card max-width="100%" outlined>
    <v-app-bar dark dense color="red lighten-1" elevation="0">
      <v-toolbar-title>Funcionarios Externos</v-toolbar-title>
      <FormCreateExternalEmployee />
    </v-app-bar>
    <v-data-table
      :headers="header"
      :items="external_employees"
      :items-per-page="5"
      :search="search"
      :custom-filter="filterExternalEmployees"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-text-field v-model="search" label="Pesquisar" class="mx-4"></v-text-field>
      </template>
      
      <template v-slot:[`item.actions`]="{ item }">
        <v-row>
          <v-col cols="3" sm="6" md="3" lg="3" xl="3" class="ml-0">
            <FormUpdateExternalEmployee :acquisitionId="item.id" />
          </v-col>
          <!-- <v-col cols="3" sm="6" md="3" lg="3" xl="3" class="pl-1 ml-0">
            <v-row>
              <v-col class="d-flex">
                <v-btn text medium icon @click="modalDeleteExternalEmployee(item.id)">
                  <v-icon medium color="red lighten-1"> mdi-close-box-outline </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col> -->
        </v-row>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import FormCreateExternalEmployee from '@/views/entities/components/FormCreateExternalEmployee'
import FormUpdateExternalEmployee from '@/views/entities/components/FormUpdateExternalEmployee'
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
  name: 'ListCategories',
  components: {
    FormCreateExternalEmployee,
    FormUpdateExternalEmployee,
  },
  data() {
    return {
      search: '',
      header: [
        { text: 'ID', value: 'id' },
        { text: 'Nome', value: 'user_name' },
        { text: 'Empresa Associada', value: 'associate_entity' },
        { text: '', value: 'actions', sortable: false },
      ],
    }
  },
  computed: {
    ...mapState('external_employees', ['external_employees']),
  },
  methods: {
    filterExternalEmployees(value, search, item) {
      search = search.toUpperCase()

      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search) !== -1
      )
    },
  },
}
</script>
